/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-const */
import { Injectable, NgZone } from '@angular/core';

import { AlertController, LoadingController, Platform, ToastController } from '@ionic/angular';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './analytics.service';
import { Preferences } from '@capacitor/preferences';
import 'cordova-plugin-purchase';
import { firstValueFrom } from 'rxjs';
import { EventService } from '@shared/services/event.service';
import { App } from '@capacitor/app';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService {
  public objectRequest: any;
  public userData: any;
  private screenUserData: any = null;
  public purchaseConfigured: boolean = false;
  public completingPurchase: boolean = false;
  public purchaseSetup: boolean = false;
  public errorTriggered: boolean = false;
  public checkoutAbandoned: boolean = false;
  public coinsDigits: any;
  public productType: string|any;
  public localVerifiedReceipt: any;
  public pricesLoadedFromStore: boolean = false;
  private loadedProductsCount: number = 0;
  private expectedProductsCount: number = 8; // 1, 10, 50, 100 coins + club, club_3, club_6, club_12
  
  constructor(
    private platform: Platform,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    public analytics: AnalyticsService,
    public eventService: EventService,
    public userService: UserService,
    public util: UtilService,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public zone: NgZone
  ) {
    this.platform.ready().then(() => {
      Preferences.get({key:'USER_DATA'}).then((val) => {
        val = val.value ? JSON.parse(val.value) : val;

        this.userData = val;
      });

      Preferences.get({key:'IN_CHECKOUT'}).then((val) => {
        val = val.value ? JSON.parse(val.value) : val;

        if (val){
          this.analytics.registerEvent(AnalyticsService.checkoutAbandoned);
          console.log('PurchaseServiceProvider.ts checkoutAbandoned event triggered');
        }

        Preferences.set({key: 'IN_CHECKOUT', value: JSON.stringify(false)}).then(()=>{
          console.log('PurchaseServiceProvider.ts inCheckout saved to DB as false')
        })
      })

      App.addListener('appStateChange', (state) => {
        if (state.isActive) {
          console.log('[PurchaseServiceProvider] App resumed')
          if (this.checkoutAbandoned) {
            this.analytics.registerEvent(AnalyticsService.checkoutAbandoned);
            console.log('PurchaseServiceProvider.ts checkoutAbandoned event triggered');
          }
          this.checkoutAbandoned = false;
          console.log('PurchaseServiceProvider.ts checkoutAbandoned set to false');
          Preferences.set({key: 'IN_CHECKOUT', value: JSON.stringify(false)}).then(()=>{
            console.log('PurchaseServiceProvider.ts inCheckout saved to DB as false')
          });
          this.errorTriggered = false;
        }
      });

    });
  }

  private loader: any;

  // Produtos
  public oneCoinId = environment.products.oneCoin.id;
  public oneCoinAlias = environment.products.oneCoin.alias;
  public tenCoinsId = environment.products.tenCoin.id;
  public tenCoinsAlias = environment.products.tenCoin.alias;
  public fiftyCoinsId = environment.products.fiftyCoin.id;
  public fiftyCoinsAlias = environment.products.fiftyCoin.alias;
  public hundredCoinsId = environment.products.hundredCoin.id;
  public hundredCoinsAlias = environment.products.hundredCoin.alias;

  public clubId = environment.products.club.id;
  public clubName = environment.products.club.name;
  public club_3_monthsId = environment.products.club_3_months.id;
  public club_3_monthsName = environment.products.club_3_months.name;
  public club_3_monthsDiscount = environment.products.club_3_months.discount;
  public club_6_monthsId = environment.products.club_6_months.id;
  public club_6_monthsName = environment.products.club_6_months.name;
  public club_6_monthsDiscount = environment.products.club_6_months.discount;
  public club_12_monthsId = environment.products.club_12_months.id;
  public club_12_monthsName = environment.products.club_12_months.name;
  public club_12_monthsDiscount = environment.products.club_12_months.discount;
  public club_30percent_off_Id = environment.products.club_30percent_off.id;
  public club_30percent_off_Name = environment.products.club_30percent_off.name;
  public club_30percent_off_Discount = environment.products.club_30percent_off.discount;


  // Preços e descontos
  public oneCoinPriceSet = environment.products.oneCoin.priceSet;
  public tenCoinPriceSet = environment.products.tenCoin.priceSet;
  public fiftyCoinPriceSet = environment.products.fiftyCoin.priceSet;
  public hundredCoinPriceSet = environment.products.hundredCoin.priceSet;

  public oneCoinPrice = environment.products.oneCoin.price;
  public tenCoinPrice = environment.products.tenCoin.price;
  public fiftyCoinPrice = environment.products.fiftyCoin.price;
  public hundredCoinPrice = environment.products.hundredCoin.price;

  public oneCoinPriceNumber = environment.products.oneCoin.priceNumber;
  public tenCoinPriceNumber = environment.products.tenCoin.priceNumber;
  public fiftyCoinPriceNumber = environment.products.fiftyCoin.priceNumber;
  public hundredCoinPriceNumber = environment.products.hundredCoin.priceNumber;

  public oneCoinPriceMicros = environment.products.oneCoin.priceMicros;
  public tenCoinPriceMicros = environment.products.tenCoin.priceMicros;
  public fiftyCoinPriceMicros = environment.products.fiftyCoin.priceMicros;
  public hundredCoinPriceMicros = environment.products.hundredCoin.priceMicros;

  public oneCoinPriceMicrosSet = environment.products.oneCoin.priceMicrosSet;
  public tenCoinPriceMicrosSet = environment.products.tenCoin.priceMicrosSet;
  public fiftyCoinPriceMicrosSet = environment.products.fiftyCoin.priceMicrosSet;
  public hundredCoinPriceMicrosSet = environment.products.hundredCoin.priceMicrosSet;

  public tenCoinDiscount = environment.products.tenCoinDiscount;
  public fiftyCoinDiscount = environment.products.fiftyCoinDiscount;
  public hundredCoinDiscount = environment.products.hundredCoinDiscount;


  public clubPriceSet = environment.products.club.priceSet;
  public club_3_monthsPriceSet = environment.products.club_3_months.priceSet;
  public club_6_monthsPriceSet = environment.products.club_6_months.priceSet;
  public club_12_monthsPriceSet = environment.products.club_12_months.priceSet;
  public club_30percent_off_PriceSet = environment.products.club_30percent_off.priceSet;

  public productCurrency = environment.products.productCurrency;
  public clubPrice = environment.products.club.price;
  public club_3_monthsPrice = environment.products.club_3_months.price;
  public club_6_monthsPrice = environment.products.club_6_months.price;
  public club_12_monthsPrice = environment.products.club_12_months.price;
  public club_30percent_off_Price = environment.products.club_30percent_off.price;


  public clubPriceMicros = environment.products.club.priceMicros;
  public club_3_monthsPriceMicros = environment.products.club_3_months.priceMicros;
  public club_6_monthsPriceMicros = environment.products.club_6_months.priceMicros;
  public club_12_monthsPriceMicros = environment.products.club_12_months.priceMicros;
  public club_30percent_off_PriceMicros = environment.products.club_30percent_off.priceMicros;

  public clubPriceMicrosSet = environment.products.club.priceMicrosSet;
  public club_3_monthsPriceMicrosSet = environment.products.club_3_months.priceMicrosSet;
  public club_6_monthsPriceMicrosSet = environment.products.club_6_months.priceMicrosSet;
  public club_12_monthsPriceMicrosSet = environment.products.club_12_months.priceMicrosSet;
  public club_30percent_off_PriceMicrosSet = environment.products.club_30percent_off.priceMicrosSet;

  public canSeeWhoLikedMe(userData: any): boolean {
    if (userData == undefined || userData == null) {
      console.log('userData within canSeeWhoLikedMe is null');
      return false;
    }
    this.userData = userData;

    let config = this.userData.config;
    if (config != undefined && userData != null) {
      if (config.seeWhoLikedEnabled) {
        return true;
      }
    }

    return this.userData[this.clubId] != null ||
      this.userData[this.club_3_monthsId] != null ||
      this.userData[this.club_6_monthsId] != null ||
      this.userData[this.club_12_monthsId] != null ||
      this.userData[this.club_30percent_off_Id] != null
  }

  public canTeleport(userData: any): boolean {
    if (userData == undefined || userData == null) {
      console.log('userData within canTeleport is null');
      return false;
    }
    this.userData = userData;
    let config = this.userData.config;
    if (config != undefined && userData != null) {
      if (config.teleportationEnabled) {
        return true;
      }
    }
    return this.isPremium(userData);

  }

  public canReorderHome(userData: any): boolean {
    if (userData == undefined || userData == null) {
      console.log('userData within canReorderHome is null');
      return false;
    }
    this.userData = userData;
    let config = this.userData.config;
    if (config != undefined && userData != null) {
      if (config.reorderEnabled) {
        return true;
      }
    }
    return this.isPremium(userData);
  }

  public isPremium(userData: any): boolean {
    return this.userData[this.clubId] != null ||
      this.userData[this.club_3_monthsId] != null ||
      this.userData[this.club_6_monthsId] != null ||
      this.userData[this.club_12_monthsId] != null ||
      this.userData[this.club_30percent_off_Id] != null
  }

  public canUseWithoutAds(userData: any): boolean {
    if (userData == undefined || userData == null) {
      console.log('userData within canUseWithoutAds is null');
      return false;
    }
    this.userData = userData;
    let config = this.userData.config;
    if (config != undefined && userData != null) {
      if (config.noAdsEnabled) {
        return true;
      }
    }

    return this.userData[this.clubId] != null ||
      this.userData[this.club_3_monthsId] != null ||
      this.userData[this.club_6_monthsId] != null ||
      this.userData[this.club_12_monthsId] != null ||
      this.userData[this.club_30percent_off_Id] != null
  }
  
  public canShowAds(userData: any): boolean {
    if (userData == undefined || userData == null) {
      console.log('userData within canShowAds is null');
      return false;
    }

    const config = userData.config;
    if (!config) {
      console.log('config is null in canShowAds');
      return false;
    }

    // Valores padrão: 7 dias e 1 match
    const daysBeforeAds = config.DAYS_BEFORE_ADS ?? 7;
    const matchesBeforeAds = config.MATCHES_BEFORE_ADS ?? 1;

    // Verificar dias desde a criação usando _id do MongoDB ObjectId
    if (!userData._id || !userData._id.$oid) {
      console.log('userData._id is null or invalid in canShowAds');
      return false;
    }

    try {
      // Os primeiros 8 caracteres hexadecimais do ObjectId representam o timestamp em segundos
      const objectIdHex = userData._id.$oid;
      const timestampHex = objectIdHex.substring(0, 8);
      const creationTimestamp = parseInt(timestampHex, 16) * 1000; // Converter para milissegundos
      const creationDate = new Date(creationTimestamp);
      const now = new Date();
      const daysSinceCreation = Math.floor((now.getTime() - creationDate.getTime()) / (1000 * 60 * 60 * 24));

      console.log(`canShowAds: User account created ${daysSinceCreation} days ago (required: ${daysBeforeAds} days)`);

      if (daysSinceCreation < daysBeforeAds) {
        console.log(`canShowAds: User account is too new (${daysSinceCreation} < ${daysBeforeAds} days)`);
        return false;
      }
    } catch (error) {
      console.error('Error calculating days since creation in canShowAds:', error);
      return false;
    }

    // Verificar número de matches
    const matchesCount = userData.matches ? (Array.isArray(userData.matches) ? userData.matches.length : 0) : 0;
    console.log(`canShowAds: User has ${matchesCount} matches (required: ${matchesBeforeAds} matches)`);

    if (matchesCount < matchesBeforeAds) {
      console.log(`canShowAds: User has insufficient matches (${matchesCount} < ${matchesBeforeAds} matches)`);
      return false;
    }

    console.log('canShowAds: User meets all criteria to see ads');
    return true;
  }

  findVerifiedPurchase(products: CdvPurchase.Product[], filter: (purchase: CdvPurchase.VerifiedPurchase) => boolean): CdvPurchase.VerifiedPurchase | undefined {
    const store = CdvPurchase.store;
    for (const product of products) {
      const purchase = store.findInVerifiedReceipts(product);
      if (!purchase) continue;
      if (filter(purchase)) return purchase;
    }

    return undefined;
  }


  // Find a local transaction for one of the provided products that passes the given filter.
  findLocalTransaction(products: CdvPurchase.Product[], filter: (transaction: CdvPurchase.Transaction) => boolean): CdvPurchase.Transaction | undefined {
    const store = CdvPurchase.store;
    // find if some of those products are part of a receipt
    for (const product of products) {
      const transaction = store.findInLocalReceipts(product);
      if (!transaction) continue;
      if (filter(transaction)) return transaction;
    }

    return undefined;
  }

  isOwned(products: CdvPurchase.Product[]): boolean {
    return !!this.findVerifiedPurchase(products, p => !p.isExpired);
  }

  isApproved(products: CdvPurchase.Product[]) {
    return !!this.findLocalTransaction(products, t => t.state === CdvPurchase.TransactionState.APPROVED);
  }

  isInitiated(products: CdvPurchase.Product[]) {
    return !!this.findLocalTransaction(products, t => t.state === CdvPurchase.TransactionState.INITIATED);
  }

  async configurePurchasing() {
    if (this.purchaseConfigured) {
      return;
    }
    this.purchaseConfigured = true;

    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase; // shortcuts

    if (!this.platform.is('cordova')) { return; }


    console.log('PurchaseServiceProvider.configurePurchasing - Starting Configurations');
    //console.log('PurchaseServiceProvider.configurePurchasing - Store is Ready: ' + JSON.stringify(status));
    //console.log('PurchaseServiceProvider.configurePurchasing - Products: ' + JSON.stringify(store.products));

    console.log('PurchaseServiceProvider.configurePurchasing - Starting Configurations');

    store.validator = environment.products.urlValidator;
    store.applicationUsername = () => this.userData?._id?.$oid;


    await this.configureProduct(this.oneCoinId, this.oneCoinAlias);
    await this.configureProduct(this.tenCoinsId, this.tenCoinsAlias);
    await this.configureProduct(this.fiftyCoinsId, this.fiftyCoinsAlias);
    await this.configureProduct(this.hundredCoinsId, this.hundredCoinsAlias);

    await this.configureProduct(this.clubId, "", true /*subscription*/);
    await this.configureProduct(this.club_3_monthsId, "", true /*subscription*/);
    await this.configureProduct(this.club_6_monthsId, "", true /*subscription*/);
    await this.configureProduct(this.club_12_monthsId, "", true /*subscription*/);
    await this.configureProduct(this.club_30percent_off_Id, "", true /*subscription*/);


    this.setupListeners();

    await store.initialize([
      this.platform.is('android') ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE
    ]);

  }

  public validateSubscriptionsStartup() {
    return;
  }

  public validateSubscriptions(userData: any) {
    return;
  }

  /**
   * Sincroniza (best-effort) o idioma da instância raiz de TranslateService usada por
   * este service antes de exibir alertas. A PurchaseService é providedIn:'root', então usa
   * uma instância separada das páginas (cada página importa TranslateModule.forRoot, isolado)
   * e pode ficar defasada — por isso os alertas saíam no idioma antigo (ex.: português).
   *
   * Nunca lança e nunca bloqueia por mais de ~1,5s. Depois de chamá-la, use translate.instant()
   * (síncrono) para montar o alerta. Assim os modais SEMPRE são exibidos: se a sincronização
   * falhar ou demorar, o alerta aparece com o que estiver carregado — evitando a regressão em
   * que uma tradução assíncrona travada impedia o modal de ser criado.
   */
  private async ensureAlertLanguage(): Promise<void> {
    try {
      await this.util.initTranslate();
      // aguarda (com teto de tempo) o carregamento do JSON do idioma atual,
      // para que translate.instant() logo em seguida venha no idioma correto.
      await Promise.race([
        firstValueFrom(this.translate.get('waitForApproval')),
        new Promise((resolve) => setTimeout(resolve, 1500)),
      ]);
    } catch (e) {
      console.log('ensureAlertLanguage: seguindo com idioma atual. ' + e);
    }
  }

  /**
   * Mapeia o código de erro do SDK de compra para uma chave de tradução amigável,
   * evitando expor ao usuário a mensagem crua (em inglês) da loja.
   * PAYMENT_CANCELLED é tratado à parte (não é erro, não exibe alerta).
   */
  private purchaseErrorMessageKey(code: number): string {
    const EC = CdvPurchase.ErrorCode;
    switch (code) {
      case EC.PAYMENT_NOT_ALLOWED:
      case EC.CLIENT_INVALID:
        return 'purchaseErrorNotAllowed';
      case EC.COMMUNICATION:
      case EC.CLOUD_SERVICE_NETWORK_CONNECTION_FAILED:
      case EC.BAD_RESPONSE:
      case EC.REFRESH:
      case EC.REFRESH_RECEIPTS:
        return 'purchaseErrorNetwork';
      case EC.PRODUCT_NOT_AVAILABLE:
      case EC.INVALID_PRODUCT_ID:
      case EC.INVALID_OFFER_IDENTIFIER:
      case EC.INVALID_OFFER_PRICE:
        return 'purchaseErrorProductUnavailable';
      case EC.PAYMENT_INVALID:
      case EC.PAYMENT_EXPIRED:
      case EC.VERIFICATION_FAILED:
      case EC.INVALID_SIGNATURE:
        return 'purchaseErrorPaymentInvalid';
      case EC.PURCHASE:
        return 'purchaseErrorPurchaseFailed';
      case EC.SUBSCRIPTIONS_NOT_AVAILABLE:
      case EC.SUBSCRIPTION_UPDATE_NOT_AVAILABLE:
      case EC.SETUP:
      case EC.LOAD:
        return 'purchaseErrorBillingUnavailable';
      case EC.UNKNOWN:
        return 'purchaseErrorUnknown';
      default:
        return 'purchaseErrorGeneric';
    }
  }

  /**
   * Reverse-lookup of CdvPurchase.ErrorCode numeric values (TS enum style).
   */
  private getErrorCodeName(code: number): string {
    const name = (CdvPurchase.ErrorCode as unknown as Record<number, string | undefined>)[code];
    return typeof name === 'string' ? name : `UNKNOWN_CODE_${code}`;
  }

  // O idioma deve ser sincronizado pelo chamador (via ensureAlertLanguage) antes desta chamada.
  async showModalWaitForApproval() {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      message:  this.translate.instant('waitForApproval'),
      buttons: [
        {
          text: 'OK',

          handler: () => {
            console.log('OK clicked');
            return;
          }
        }
      ]

    });

    (await alert).present();
  }

  refreshUI(product:any) {
    if (product && product.offers && typeof product.offers[0] != undefined) {
      this.checkoutAbandoned = false;
      console.log('PurchaseServiceProvider.ts checkoutAbandoned set to false');
    }

    if (product.offers[0].pricingPhases[0].price != null) {
      try {
        this.productCurrency = product.offers[0].pricingPhases[0].currency;
        switch (product.id) {
          case this.oneCoinId:
            this.oneCoinPrice = product.offers[0].pricingPhases[0].price;
            this.oneCoinPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.oneCoinPriceMicrosSet = true;
            if (this.tenCoinPriceMicrosSet) {
              this.tenCoinDiscount = 100 * (1 - (this.tenCoinPriceMicros / (10 * this.oneCoinPriceMicros)));
            }
            if (this.fiftyCoinPriceMicrosSet) {
              this.fiftyCoinDiscount = 100 * (1 - (this.fiftyCoinPriceMicros / (50 * this.oneCoinPriceMicros)));
            }
            if (this.hundredCoinPriceMicrosSet) {
              this.hundredCoinDiscount = 100 * (1 - (this.hundredCoinPriceMicros / (100 * this.oneCoinPriceMicros)));
            }
            this.oneCoinPriceSet = true;
            break;
          case this.tenCoinsId:
            this.tenCoinPrice = product.offers[0].pricingPhases[0].price;
            this.tenCoinPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.tenCoinPriceMicrosSet = true;
            if (this.oneCoinPriceMicrosSet) {
              this.tenCoinDiscount = 100 * (1 - (this.tenCoinPriceMicros / (10 * this.oneCoinPriceMicros)));
            }
            this.tenCoinPriceSet = true;
            break;
          case this.fiftyCoinsId:
            this.fiftyCoinPrice = product.offers[0].pricingPhases[0].price;
            this.fiftyCoinPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.fiftyCoinPriceMicrosSet = true;
            if (this.oneCoinPriceMicrosSet) {
              this.fiftyCoinDiscount = 100 * (1 - (this.fiftyCoinPriceMicros / (50 * this.oneCoinPriceMicros)));
            }
            this.fiftyCoinPriceSet = true;
            break;
          case this.hundredCoinsId:
            this.hundredCoinPrice = product.offers[0].pricingPhases[0].price;
            this.hundredCoinPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.hundredCoinPriceMicrosSet = true;
            if (this.oneCoinPriceMicrosSet) {
              this.hundredCoinDiscount = 100 * (1 - (this.hundredCoinPriceMicros / (100 * this.oneCoinPriceMicros)));
            }
            this.hundredCoinPriceSet = true;
            break;
          case this.clubId:
            this.clubPrice = product.offers[0].pricingPhases[0].price;
            this.clubPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.clubPriceMicrosSet = true;
            if (this.club_3_monthsPriceMicrosSet) {
              this.club_3_monthsDiscount = 100 * (1 - (this.club_3_monthsPriceMicros / (3 * this.clubPriceMicros)));
            }
            if (this.club_6_monthsPriceMicrosSet) {
              this.club_6_monthsDiscount = 100 * (1 - (this.club_6_monthsPriceMicros / (6 * this.clubPriceMicros)));
            }
            if (this.club_12_monthsPriceMicrosSet) {
              this.club_12_monthsDiscount = 100 * (1 - (this.club_12_monthsPriceMicros / (12 * this.clubPriceMicros)));
            }
            // if (this.club_30percent_off_PriceMicrosSet) {
            //   this.club_30percent_off_Discount = 100 * (1 - (this.club_30percent_off_PriceMicros / this.clubPriceMicros));
            // }
            this.clubPriceSet = true;
            break;
          case this.club_3_monthsId:
            this.club_3_monthsPrice = product.offers[0].pricingPhases[0].price;
            this.club_3_monthsPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.club_3_monthsPriceMicrosSet = true;
            if (this.clubPriceMicrosSet) {
              this.club_3_monthsDiscount = 100 * (1 - (this.club_3_monthsPriceMicros / (3 * this.clubPriceMicros)));
            }
            this.club_3_monthsPriceSet = true;
            break;
          case this.club_6_monthsId:
            this.club_6_monthsPrice = product.offers[0].pricingPhases[0].price;
            this.club_6_monthsPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.club_6_monthsPriceMicrosSet = true;
            if (this.clubPriceMicrosSet) {
              this.club_6_monthsDiscount = 100 * (1 - (this.club_6_monthsPriceMicros / (6 * this.clubPriceMicros)));
            }
            this.club_6_monthsPriceSet = true;
            break;
          case this.club_12_monthsId:
            this.club_12_monthsPrice = product.offers[0].pricingPhases[0].price;
            this.club_12_monthsPriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.club_12_monthsPriceMicrosSet = true;
            if (this.clubPriceMicrosSet) {
              this.club_12_monthsDiscount = 100 * (1 - (this.club_12_monthsPriceMicros / (12 * this.clubPriceMicros)));
            }
            this.club_12_monthsPriceSet = true;
            break;
          case this.club_30percent_off_Id:
            this.club_30percent_off_Price = product.offers[0].pricingPhases[0].price;
            this.club_30percent_off_PriceMicros = product.offers[0].pricingPhases[0].priceMicros;
            this.club_30percent_off_PriceMicrosSet = true;
            if (this.clubPriceMicrosSet) {
              this.club_30percent_off_Discount = 100 * (1 - (this.club_30percent_off_PriceMicros / this.clubPriceMicros));
            }
            this.club_30percent_off_PriceSet = true;
            break;


        }

        this.loadedProductsCount++;
        if (this.loadedProductsCount >= this.expectedProductsCount) {
          this.pricesLoadedFromStore = true;
        }

      } catch (error) {
        console.log('PurchaseServiceProvider.configureProduct - Updated. Error getting the localized price: ' + JSON.stringify(error));
      }
    }
  }

  configureProduct(productId: string, productAlias?: string, subscriptionProduct?: boolean) {
    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase; // shortcuts
    try {

      //productId = 'com.leftyapp.' + productId;

      // Register Product
      store.verbosity = LogLevel.DEBUG;

      if (subscriptionProduct) {

        console.log('PurchaseServiceProvider.configureProduct - Registering Subscription ' + JSON.stringify(productId));
        store.register({
          id: productId,
          type: ProductType.PAID_SUBSCRIPTION,
          platform: this.platform.is('android') ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE
        });

      } else {
        console.log('PurchaseServiceProvider.configureProduct - Registering Consumable ' + JSON.stringify(productId));
        store.register({
          id: productId,
          type: ProductType.CONSUMABLE,
          platform: this.platform.is('android') ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE
        });
      }
    } catch (err) {
      console.error('PurchaseServiceProvider.configurePurchasing - Error On Store Issues: ' + JSON.stringify(err));
    }
  }

  setupListeners() {
    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase; // shortcuts
    

    store.when().finished(async (receipt: any) => {
      // alert("finished")
      // this.processVerified(transaction)

      console.log(JSON.stringify(receipt))
      console.log(JSON.stringify(this.localVerifiedReceipt))
      localStorage.setItem("dataTransactionReceipt", JSON.stringify(receipt))
      localStorage.setItem("dataLocalVerifiedReceipt", JSON.stringify(this.localVerifiedReceipt))
    })

    store.when().verified(async (receipt: any) => {
      this.localVerifiedReceipt = await receipt;
      localStorage.setItem("localVerifiedReceipt", JSON.stringify(receipt))
      receipt.finish();
      await this.processVerified(receipt);
      console.log("transaction finish");
    });

    store.when().productUpdated((product: CdvPurchase.Product) => {
      this.zone.run(() => {
        this.refreshUI(product)
      });
    });

    store.when().approved((transaction) => {
      transaction.verify();
      localStorage.setItem('transactionApproved', JSON.stringify(transaction))
    });

    // store.when(productId).cancelled((product) => {
    //   console.log('PurchaseServiceProvider.configureProduct - Purchase was Cancelled. ' + JSON.stringify(product));
    //   if (product.transaction != null) {
    //     let alert = this.alertCtrl.create({
    //       title: this.translate.instant('errorFromYourLastTransaction'),
    //       subTitle: 'Purchase failed: BILLING_UNAVAILABLE',
    //       buttons: [
    //         {
    //           text: 'OK',
    //           handler: () => {}
    //         }
    //       ]
    //     });
    //     alert.present();
    //     this.analytics.registerEvent(AnalyticsProvider.checkoutPayFail);
    //     console.log('PurchaseServiceProvider.ts checkoutPayFail event triggered');
    //   } else {
    //     this.checkoutAbandoned = true;
    //     console.log('PurchaseServiceProvider.ts checkoutAbandoned set to true');
    //   }
    //   //        console.log('PurchaseServiceProvider.configureProduct - Purchase was Cancelled. state=: ' + product.state);
    //   if (this.loader != null) {
    //     this.loader.dismiss();
    //     this.loader = null;
    //   }
    // });

    // store.when(productId).expired((product) => {
    //   console.log('PurchaseServiceProvider.configureProduct - Purchase was expired. ' + JSON.stringify(product));

    //   if (this.loader != null) {
    //     this.loader.dismiss();
    //     this.loader = null;
    //   }
    // });

    store.error((err) => {
      void this.handleStoreError(err);
    });

  }

  /**
   * Handles store purchase errors: local diagnostics, user alert, and analytics.
   * Extracted for unit testing. Must not throw — analytics/localStorage failures
   * should never block the user-facing alert or purchase error recovery.
   */
  private async handleStoreError(err: { code: number; message?: string }): Promise<void> {
    const errorCodeName = this.getErrorCodeName(err.code);
    // IAP is native-only; there is no sale on web. Check ios explicitly so web/desktop
    // is not mislabeled as "iOS" when platform.is('android') is false.
    const platform = this.platform.is('android')
      ? 'Android'
      : this.platform.is('ios')
        ? 'iOS'
        : 'Web';
    const isCancelled = err.code == CdvPurchase.ErrorCode.PAYMENT_CANCELLED;

    // Always log for checkout debugging (including cancel). Do not persist cancel
    // as LAST_PURCHASE_ERROR — it would overwrite a prior real failure.
    try {
      const details = JSON.stringify({
        platform,
        code: err.code,
        codeName: errorCodeName,
        message: err.message,
        error: err,
      });
      if (isCancelled) {
        console.log(
          'PurchaseServiceProvider.configureProduct - Purchase cancelled by user:',
          details
        );
      } else {
        console.error(
          'PurchaseServiceProvider.configureProduct - Purchase had an error:',
          details
        );
      }
    } catch (logErr) {
      console.error('Failed to log purchase error details:', logErr);
    }

    if (!isCancelled) {
      try {
        localStorage.setItem(
          'LAST_PURCHASE_ERROR',
          JSON.stringify({
            timestamp: new Date().toISOString(),
            platform,
            errorCode: err.code,
            errorCodeName,
            errorMessage: err.message,
            fullError: JSON.stringify(err),
          })
        );
      } catch (storageErr) {
        console.error('Failed to store LAST_PURCHASE_ERROR:', storageErr);
      }
    }

    if (!this.errorTriggered) {
      if (isCancelled) {
        // O usuário cancelou: não é erro. Só registra analytics, sem alerta.
        try {
          this.analytics.registerEvent(AnalyticsService.checkoutAbandoned);
          console.log('PurchaseServiceProvider.ts checkoutAbandoned event triggered');
        } catch (analyticsErr) {
          console.error('Failed to register checkoutAbandoned:', analyticsErr);
        }
      } else {
        // Traduz o motivo do erro em vez de mostrar a mensagem crua (em inglês) do SDK.
        await this.ensureAlertLanguage();

        // Non-production only: surface the store error code for QA/debug builds.
        // Use <br> (Ionic alert message is HTML); plain \n collapses in the UI.
        const isDevelopment = !environment.production;
        const diagnosticInfo = isDevelopment
          ? `<br><br>[Debug Info] Error Code: ${errorCodeName} (${err.code})`
          : undefined;

        try {
          const alert = this.alertCtrl.create({
            header: this.translate.instant('errorFromYourAppStore'),
            subHeader: this.translate.instant(this.purchaseErrorMessageKey(err.code)),
            message: diagnosticInfo,
            buttons: [
              {
                text: 'OK',
                handler: () => { }
              }
            ]
          });
          (await alert).present();
        } catch (alertErr) {
          console.error('Failed to present purchase error alert:', alertErr);
        }

        if (err.code == CdvPurchase.ErrorCode.PURCHASE) {
          try {
            this.analytics.registerEvent(AnalyticsService.checkoutPayFail);
            console.log('PurchaseServiceProvider.ts checkoutPayFail event triggered');
          } catch (analyticsErr) {
            console.error('Failed to register checkoutPayFail:', analyticsErr);
          }
        }

        try {
          // Truncate for Firebase/Meta param length limits (~100 chars).
          // Do not send Mongo user _id — that is PII for Firebase/Meta policies.
          const safeMessage = (err.message || 'Unknown').toString().slice(0, 100);
          this.analytics.registerEvent({
            eventName: 'purchase_error',
            params: {
              error_code: err.code,
              error_code_name: errorCodeName,
              error_message: safeMessage,
              platform,
            }
          });
        } catch (analyticsErr) {
          console.error('Failed to register purchase_error analytics:', analyticsErr);
        }
      }
      this.checkoutAbandoned = false;
      console.log('PurchaseServiceProvider.ts checkoutAbandoned set to false');
      this.errorTriggered = true;
    }
    if (this.loader != null) {
      this.loader.dismiss();
      this.loader = null;
    }
  }

  private async processVerified(receipt: any) {
    // shortcuts

    let collection = receipt.collection;
    //let nonExpiredSubscriptions = null;
    localStorage.setItem("COLLECTION", JSON.stringify(collection));
    // for (let item of collection) {
    //   if (!item.isExpired) {
    //     alert(item.isExpired)
    //     nonExpiredSubscriptions = item;
    //     //break;
    //   }
    // }
    const consumable = collection.filter((consumable: any) => !consumable.hasOwnProperty('expiryDate'));
    if (consumable != null && consumable.length > 0) {
      await this.sendConsumables(receipt, consumable[0]);
      // Do not return early: Apple receipts can include prior consumables alongside
      // a new subscription. Skipping subscriptions here drops premium/checkout analytics.
    }

    const nonExpiredSubscriptions = collection.filter((subscription: any) => subscription.isExpired === false);
    if (nonExpiredSubscriptions !== null && nonExpiredSubscriptions.length > 0) {
      await this.sendSubscriptions(receipt, nonExpiredSubscriptions);
    }
  }

  async sendConsumables(receipt: any, consumable:any) {
    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase;

    if (this.platform.is('android')) {
      localStorage.setItem("this.localVerifiedReceipt", JSON.stringify(this.localVerifiedReceipt))
      this.objectRequest = {
        id: consumable.id, // already included by plugin 
        type: ProductType.CONSUMABLE,
        transaction: {
          type: Platform.GOOGLE_PLAY,//transaction.nativePurchase.expiryTimeMillis
          purchaseToken: receipt.sourceReceipt.purchaseToken
        },
      }
    } else {
      this.objectRequest = {
        id: consumable.id, // already included by plugin 
        //transactionId: receipt.nativeTransactions[0].in_app[0].transaction_id,
        type: ProductType.CONSUMABLE,
        transaction: {
          type: Platform.APPLE_APPSTORE,
          appStoreReceipt: receipt.sourceReceipt.nativeData.appStoreReceipt
        },
      }
    }
    this.objectRequest = { ...this.localVerifiedReceipt, ...this.objectRequest };
    this.attachStorePricing(this.objectRequest, consumable.id, receipt);
    await this.completePurchaseInServer(this.objectRequest);
  }

  async sendSubscriptions(receipt: any, subscriptions:any) {
    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase;
    await subscriptions.forEach(async (subscription: any) => {
      if (this.platform.is('android')) {
        localStorage.setItem("this.localVerifiedReceipt", JSON.stringify(this.localVerifiedReceipt))
        this.objectRequest = {
          id: subscription.id, // already included by plugin 
          type: ProductType.PAID_SUBSCRIPTION,
          transaction: {
            type: Platform.GOOGLE_PLAY,//transaction.nativePurchase.expiryTimeMillis
            purchaseToken: receipt.sourceReceipt.purchaseToken,
            expiryTimeMillis: subscription.expiryDate
          }
        }
      } else {
        this.objectRequest = {
          id: subscription.id, // already included by plugin 
          //transactionId: receipt.nativeTransactions[0].in_app[0].transaction_id,
          type: ProductType.PAID_SUBSCRIPTION,
          transaction: {
            expiryTimeMillis: subscription.expiryDate,
            expires_date_ms: subscription.expiryDate,
            type: Platform.APPLE_APPSTORE,
            appStoreReceipt: receipt.sourceReceipt.nativeData.appStoreReceipt
          },
        }
      }
      //alert(JSON.stringify(this.objectRequest))
      this.objectRequest = { ...this.localVerifiedReceipt, ...this.objectRequest };
      this.attachStorePricing(this.objectRequest, subscription.id, receipt);
      console.log("================typePayment================")
      console.log(this.objectRequest)
      await this.completePurchaseInServer(this.objectRequest);
    });
  }

  /**
   * VerifiedReceipt payloads omit catalog pricing. Attach price fields from the
   * store product so SoulService can persist them for affiliate commission.
   */
  private attachStorePricing(request: any, productId: string, receipt?: any): any {
    if (!request || !productId) {
      return request;
    }
    try {
      const store = CdvPurchase.store;
      const product = store.get(productId);
      const phase = product && product.offers && product.offers[0]
        && product.offers[0].pricingPhases && product.offers[0].pricingPhases[0];
      if (phase) {
        if (phase.priceMicros != null) {
          request.priceMicros = phase.priceMicros;
        }
        if (phase.price != null) {
          request.price = phase.price;
        }
        if (phase.currency != null) {
          request.currency = phase.currency;
        }
      }
      if (product && (product as any).countryCode) {
        request.countryCode = (product as any).countryCode;
      }
      if (!request.countryCode && receipt && receipt.nativeTransactions
        && receipt.nativeTransactions[0] && receipt.nativeTransactions[0].regionCode) {
        request.countryCode = receipt.nativeTransactions[0].regionCode;
      }
      if (!request.currency && this.productCurrency) {
        request.currency = this.productCurrency;
      }
    } catch (e) {
      console.warn('attachStorePricing failed for ' + productId, e);
    }
    return request;
  }

  getExpirationDateExists() {
    if (this.userData !== undefined) {
      if (
        this.userData[environment.products.club.id] !== undefined ||
        this.userData[environment.products.club_3_months.id] !== undefined ||
        this.userData[environment.products.club_6_months.id] !== undefined ||
        this.userData[environment.products.club_12_months.id] !== undefined) {

        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      translucent: true,

      backdropDismiss: true
    });

    loading.present();
  }

  async purchase(me: any, productId: string, coinsDigitsPtr: any): Promise<boolean> {
    this.purchaseSetup = true;
    const store = CdvPurchase.store;
    const { ProductType, Platform, LogLevel, Product, VerifiedReceipt } = CdvPurchase; // shortcuts
    
    // Sincroniza o idioma dos alertas UMA vez (evita corrida entre chamadas concorrentes).
    await this.ensureAlertLanguage();

    this.showModalWaitForApproval();
    this.errorTriggered = false;
    this.coinsDigits = coinsDigitsPtr;
    this.userData = me;
    this.screenUserData = me;

    this.showLoading(this.translate.instant('completingTransaction'));
  
    await Preferences.set({ key: 'IN_CHECKOUT', value: JSON.stringify(true) });
    console.log('PurchaseServiceProvider.ts inCheckout saved to DB as true');
  
    this.analytics.registerEvent(AnalyticsService.checkoutStart);
    console.log('PurchaseServiceProvider.ts checkoutStart event triggered');
  
    try {
      console.log('PurchaseServiceProvider.purchase - before store.initialize');
      await store.initialize([
        this.platform.is('android') ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE
      ]);
      console.log('PurchaseServiceProvider.purchase - after store.initialize');
  
      if (!this.platform.is('cordova')) {
        if (this.loader) {
          this.loader.dismiss();
          this.loader = null;
        }
        return false; // Indicate failure
      }
  
      console.log('PurchaseServiceProvider.ts - Will call store.get()..');
      let product = store.get(productId);
      this.productType = product?.type;
  
      console.log('PurchaseServiceProvider.ts - Product Info: ' + JSON.stringify(product));
      console.log('PurchaseServiceProvider.ts - Will call order() on: ' + productId);
  
      let getOffer: any = product?.getOffer();
      
      return store.order(getOffer).then(
        (success) => {
          if (this.loader) {
            this.loader.dismiss();
            this.loader = null;
          }
          if (!success){
            return true; // Purchase sucesfulll
          }
          return false; // Purchase Failed
        },
        (error: Error) => {
          console.log('PurchaseServiceProvider.ts - Error Ordering From Store: ' + JSON.stringify(error));
          if (this.loader) {
            this.loader.dismiss();
            this.loader = null;
          }
          return false; // Purchase failed
        }
      );
    } catch (err) {
      console.log('PurchaseServiceProvider.ts - Caught error Ordering ' + JSON.stringify(err));
      if (this.loader) {
        this.loader.dismiss();
        this.loader = null;
      }
      return false; // Purchase failed
    }
  }

  private async completePurchaseInServer(product:any) {
    console.log('purchase-service.completePurchaseInServer called...');

    if (!this.userData || !this.userData._id || !this.userData._id.$oid) {
      console.log('purchase-service.completePurchaseInServer: userData ou $oid está indefinido, não processando agora');
      this.util.showTopToastUnableToConnect(this.toastCtrl);
      return;
    }
    if (this.completingPurchase) {
      console.log('purchase-service.completePurchaseInServer: already in progress, skipping duplicate');
      return;
    }
    this.completingPurchase = true;

    const theObs = this.userService.completePurchase(this.userData, product);

    try {
      const data = await firstValueFrom(theObs);
      console.log('purchase-service.completePurchaseInServer: completePurchase response received');
      console.log(JSON.stringify(data));
      if (data == '{not ok}') {
        if (this.loader != null) {
          this.loader.dismiss();
          this.loader = null;
        }
        return;
      }
      if (data == '{ignore}') {
        if (this.loader != null) {
          this.loader.dismiss();
          this.loader = null;
        }
        return;
      }
      this.userData = JSON.parse(data);
      const coins: number = this.userData?.coins;

      console.log('purchase-service.completePurchaseInServer - coins: ' + coins);

      await Preferences.set({key: 'USER_DATA', value: JSON.stringify(this.userData)});
      console.log('userdata saved to DB');
      this.eventService.publish('userDataUpdated', this.userData);

      if (this.screenUserData != null) {
        this.eventService.publish('updateCoins', coins);
        this.screenUserData.coins = coins;
      }

      if (this.userData?.coins != null) {
        const coinsStr = '' + this.userData?.coins;
        if (this.coinsDigits != undefined) {
          this.coinsDigits.digits = coinsStr.length;
        }
      }

      const isSubscription = product.id == this.clubId ||
        product.id == this.club_3_monthsId ||
        product.id == this.club_6_monthsId ||
        product.id == this.club_12_monthsId ||
        product.id == this.club_30percent_off_Id;

      console.log('PurchaseServiceProvider.ts: isSubcription: ' + isSubscription);

      if (isSubscription) {
        this.analytics.registerEvent({
          ...AnalyticsService.avcdCheckoutSuccess,
          params: this.buildCheckoutEventParams(product.id)
        });
        console.log('PurchaseServiceProvider.ts checkoutSuccess event triggered');

        // Meta Purchase (Fyra auto uses Subscribe). Firebase in_app_purchase is auto-only.
        this.sendStorePurchaseAnalyticsIfNeeded(product.id, true);

        this.userData.showAvocadoClubIndicator = true;

        const lastLocRes = await Preferences.get({key:'LAST_LOCATION'});
        const lastLoc = lastLocRes.value ? JSON.parse(lastLocRes.value) : null;
        const upsertObs = this.userService.upsertSoul(this.userData, lastLoc, false, false, false);
        const upsertData = await firstValueFrom(upsertObs);
        console.log('purchase-service.completePurchaseInServer: upsert completed');

        if (upsertData != '{not ok}') {
          const userDataLocal = JSON.parse(upsertData);
          await Preferences.set({key: 'USER_DATA',value: JSON.stringify(userDataLocal)});
          console.log('userdata saved to DB');
          this.eventService.publish('userDataUpdated', userDataLocal);
        }
      } else {
        this.analytics.registerEvent({
          ...AnalyticsService.crrtCheckoutSuccess,
          params: this.buildCheckoutEventParams(product.id)
        });
        console.log('PurchaseServiceProvider.ts checkoutSuccess event triggered');

        // Meta Purchase on Android (iOS coins use auto). Firebase in_app_purchase is auto-only.
        this.sendStorePurchaseAnalyticsIfNeeded(product.id, false);
      }

      console.log('PurchaseServiceProvider.configurePurchasing - Product purchase finished');

      await this.ensureAlertLanguage();
      this.alertCtrl.create({
        header: this.translate.instant(isSubscription ? 'subscriptionSuccessful' : 'purchaseSuccessful'),
        message: this.translate.instant('thanksalotAndGoodLuck'),
        buttons: [
          {
            text: 'OK',
            role: 'cancel'
          }
        ]
      });
      //(await alert).present();

      if (this.loader != null) {
        this.loader.dismiss();
        this.loader = null;
      }
    } catch (err) {
      console.log('Error: ' + JSON.stringify(err));
      if (this.loader != null) {
        this.loader.dismiss();
        this.loader = null;
      }
      this.util.showToastUnableToConnect(this.toastCtrl);
    } finally {
      this.completingPurchase = false;
    }
  }

  public isPricesLoadedFromStore(): boolean {
    return this.pricesLoadedFromStore;
  }

  /**
   * Restaura compras anteriores (exigido pela Apple para apps com IAP).
   * Chama store.restorePurchases() que dispara os callbacks de verified/approved para compras existentes.
   */
  async restorePurchases(): Promise<void> {
    const store = CdvPurchase.store;

    if (!this.platform.is('cordova')) {
      console.log('restorePurchases: Not on cordova, skipping');
      return;
    }

    console.log('restorePurchases: Starting restore...');
    try {
      await store.restorePurchases();
      console.log('restorePurchases: Restore completed');
    } catch (err) {
      console.error('restorePurchases: Error restoring purchases:', err);
      throw err;
    }
  }

  /**
   * Sends Meta/Firebase store analytics with value and currency after a verified purchase.
   * Meta Purchase for Fyra subs + Android coins. Firebase in_app_purchase is auto-only.
   */
  private sendStorePurchaseAnalyticsIfNeeded(productId: string, isSubscription: boolean): void {
    try {
      const pricing = this.getStoreProductPricing(productId);
      if (!pricing) {
        return;
      }

      console.log(
        `sendStorePurchaseAnalyticsIfNeeded: ${productId} - ${pricing.priceMicros} micros, ${pricing.currency}, subscription=${isSubscription}`
      );
      this.analytics.sendStorePurchaseAnalytics(
        productId,
        pricing.priceMicros,
        pricing.currency,
        isSubscription
      );
    } catch (error) {
      console.error('sendStorePurchaseAnalyticsIfNeeded: Error:', error);
    }
  }

  private buildCheckoutEventParams(productId: string): Record<string, string | number> {
    const pricing = this.getStoreProductPricing(productId);
    if (!pricing) {
      return { product_id: productId };
    }
    const value = pricing.priceMicros / 1000000;
    return {
      product_id: productId,
      value,
      currency: pricing.currency,
      price: value
    };
  }

  private getStoreProductPricing(productId: string): { priceMicros: number; currency: string } | null {
    try {
      const store = CdvPurchase.store;
      const product = store.get(productId);

      if (!product) {
        console.warn(`getStoreProductPricing: Product ${productId} not found in store`);
        return null;
      }

      const offer = product.offers && product.offers[0];
      if (!offer || !offer.pricingPhases || !offer.pricingPhases[0]) {
        console.warn(`getStoreProductPricing: No pricing information for product ${productId}`);
        return null;
      }

      const pricingPhase = offer.pricingPhases[0];
      const priceMicros = pricingPhase.priceMicros;
      const currency = pricingPhase.currency;

      if (!priceMicros || !currency) {
        console.warn(`getStoreProductPricing: Missing price or currency for product ${productId}`);
        return null;
      }

      return { priceMicros, currency };
    } catch (error) {
      console.error('getStoreProductPricing: Error:', error);
      return null;
    }
  }

}
